import React, { useRef } from 'react';
import { Typography, Grid } from 'antd';
import { motion } from 'framer-motion';

const { useBreakpoint } = Grid;

const Shop: React.FC = () => {
  const videoRef = useRef<HTMLVideoElement>(null);
  const screens = useBreakpoint();
  const isMobile = !screens.md;



  const handleVideoClick = () => {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
      } else {
        videoRef.current.pause();
      }
    }
  };

  return (
    <div
      style={{
        padding: '40px 16px',
        textAlign: 'center',
        maxWidth: 900,
        margin: '0 auto',
      }}
    >
      {/* Video Section */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        style={{ marginBottom: 32 }}
      >
        <div
          style={{
            position: 'relative',
            paddingBottom: isMobile ? '100%' : '56.25%', // taller on mobile
            height: 0,
            overflow: 'hidden',
            borderRadius: 12,
            boxShadow: '0 0 16px rgba(0,0,0,0.2)',
            backgroundColor: '#000',
            cursor: 'pointer',
          }}
          onClick={handleVideoClick}
        >
          <video
            ref={videoRef}
            src="/tshirtssale.MP4"
            autoPlay
            muted
            loop
            playsInline
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: 12,
              objectFit: 'contain',
            }}
          />
        </div>
      </motion.div>

      {/* Coming Soon Text */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.4 }}
      >
        <Typography.Title style={{ fontSize: '1.5rem' }}>🛍️ Shop Coming Soon 🛍️</Typography.Title>
      </motion.div>
    </div>
  );
};

export default Shop;
